import makeApolloClient from '../shared/helpers/make-apollo-client/make-apollo-client-with-local-state'

export default function apolloClient(isHmr) {
  let hydrateCacheFrom = null
  let schema = null
  if (typeof window !== 'undefined') {
    hydrateCacheFrom = isHmr ? null : window.__APOLLO_STATE__
    schema = window.__GRAPHQL_SCHEMA__
  }
  const clientOpts = { shouldBatch: true }
  return makeApolloClient({ hydrateCacheFrom, schema, clientOpts })
}
